import { Navigate, Outlet, useLocation } from "react-router-dom";

const ProtectedRoute = () => {
  const location = useLocation();
  const token = localStorage.getItem("token");

  const isAuthenticated = token && token !== "undefined";

  if (!isAuthenticated) {
    return (
      <Navigate
        to={`/account?redirect=${encodeURIComponent(
          location.pathname + location.search,
        )}`}
        replace
      />
    );
  }

  return <Outlet />;
};

export default ProtectedRoute;
